import { Component, OnInit, Inject, AfterViewInit } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { FormControl, Validators, UntypedFormBuilder, UntypedFormArray, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as  _ from 'lodash';
import { MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { OrderService } from '@app/_services';
import { ToastrService } from 'ngx-toastr';
import { TranslateHelper } from '@app/_helpers';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgIf, NgFor } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { FlexModule } from '@angular/flex-layout/flex';

@Component({
    selector: 'app-return-order-dialog',
    templateUrl: './return-order-dialog.component.html',
    styleUrls: ['./return-order-dialog.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [MatDialogTitle, FlexModule, MatDividerModule, MatDialogContent, FormsModule, ReactiveFormsModule, NgIf, NgFor, MatCheckboxModule, MatFormFieldModule, MatSelectModule, MatOptionModule, MatInputModule, MatDialogActions, MatButtonModule, TranslateModule]
})
export class ReturnReasonsDialogComponent implements OnInit, AfterViewInit {

    constructor(private dialogref: MatDialogRef<any>, private fb: UntypedFormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private toastr: ToastrService,
        private orderService: OrderService,
        public translate: TranslateService,
        public translateHelper: TranslateHelper) {

    }



    form = this.fb.group({
        _id: [this.data.orderId],
        other: [{ value: '', disabled: true }, [Validators.required]],
        note: ['',],
        items: this.fb.array([])
    });

    reasons = [];

    itemsForm = this.form.get("items") as UntypedFormArray;
    items: any[] = this.data.items || [];

    ngAfterViewInit(): void {
        this.data?.items?.forEach(element => {
            this.itemsForm.push(this.fb.group({
                _id: element.itemId,
                return: [false],
                reason: [{ value: '', disabled: true }, [Validators.required]],
                amount: [{ value: element.amount || 1, disabled: true }, [Validators.required, Validators.pattern('[0-9]+(\.[0-9][0-9]?)?')]],
                other: [{ value: '', disabled: true }, [Validators.required]],
                note: [],
            }))
        });


    }
    ngOnInit(): void {
        this.orderService.getReturnReasonsList().subscribe((res) => {
            if (res.code == 200) this.reasons = res.data || [];
            this.reasons.push({ en: "Other", ar: "أخرى" });
        });




    }

    toggleItem(event, control: UntypedFormGroup) {
        if (event.checked) {
            control?.get("reason")?.enable();
            control?.get("note")?.enable();
            control?.get("amount")?.enable();
        } else {
            control?.get("reason")?.disable();
            control?.get("note")?.disable();
            control?.get("amount")?.disable();

        }
        //control.updateValueAndValidity();
    }

    submit() {
        if (this.form.invalid) {
            this.toastr.error(this.translateHelper.getTranslation("please_write_reason"));
            return;
        }

        let formValue = _.cloneDeep(this.form.value);

        let itemsValue = [];

        formValue?.items?.forEach(item => {
            if (!item.return) return
            itemsValue.push({
                _id: item._id,
                reason: item.reason == "Other" || item.reason == "أخرى" ? item.other : item.reason,
                amount: item.amount,
                note: item.note
            });
        });

        if (!itemsValue?.length) return this.toastr.error(this.translateHelper.getTranslation("please_select_item"));

        formValue.items = itemsValue;
        this.dialogref.close(formValue);
    }

    onChange(event, form) {
        if (event.value == 'Other' || event.value == 'أخرى') form.get('other').enable();
        else {
            form.get('other').disable();

        }
    }

    validateAmount( itemAmount: number, control: UntypedFormGroup) {
        if (control.get('amount').value > itemAmount) {
            control.get("amount").setValue(itemAmount);
        }
        else if (control.get('amount').value < 0) {
            control.get("amount").setValue(0);
        }
    }

}
